
function About() {
    return ( 
        <div className="AppAbout">                
        </div>
    );
}

export default About;